import { Text, Image, Carousel } from '@belong/ui';
import { clsx } from 'clsx';
import { AGREEMENT_SUMARY } from 'pages/AgreementFlow/consts';

type Props = {
  // Optional because the caller derives it from an optional `some(...)`, and
  // every read below is a truthiness check.
  isAdoptedInvitation?: boolean;
};

export const AgreementSummary = ({ isAdoptedInvitation }: Props) => {
  const agreementSummaryItems = AGREEMENT_SUMARY.filter(
    (agreementSummaryItem) => {
      if (
        isAdoptedInvitation &&
        ['guaranteed-rent', 'eviction-protection'].includes(
          agreementSummaryItem.key,
        )
      ) {
        return false;
      }

      return true;
    },
  );

  return (
    <>
      <div className="md:hidden">
        <Carousel>
          {agreementSummaryItems.map((agreementSummaryItem) => (
            <div className="min-w-full" key={agreementSummaryItem.title}>
              <Image
                alt={agreementSummaryItem.title}
                className="mx-auto mb-sm h-2xl w-2xl"
                src={agreementSummaryItem.image}
              />
              <Text fontWeight="semibold" className="mb-2xs text-center">
                {agreementSummaryItem.title}
              </Text>
              <Text variant="p1">{agreementSummaryItem.description}</Text>
            </div>
          ))}
        </Carousel>
      </div>
      <div
        className={clsx(
          'hidden md:grid md:gap-xl',
          isAdoptedInvitation ? 'md:grid-cols-2' : 'md:grid-cols-3',
        )}
      >
        {agreementSummaryItems.map((agreementSummaryItem) => (
          <div key={agreementSummaryItem.title}>
            <Image
              alt={agreementSummaryItem.title}
              className="mb-sm h-2xl w-2xl"
              src={agreementSummaryItem.image}
            />
            <Text fontWeight="semibold" className="mb-2xs">
              {agreementSummaryItem.title}
            </Text>
            <Text variant="p1">{agreementSummaryItem.description}</Text>
          </div>
        ))}
      </div>
    </>
  );
};
